import React from 'react';
import generateSitemap from '../utils/generateSitemap';

const SitemapGenerator = () => {
  const handleGenerateSitemap = () => {
    const sitemapContent = generateSitemap();
    
    // Create and download sitemap file
    const blob = new Blob([sitemapContent], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sitemap.xml';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleViewSitemap = () => {
    const sitemapContent = generateSitemap();
    const newWindow = window.open();
    newWindow.document.write(`<pre>${sitemapContent}</pre>`);
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Sitemap Generator</h2>
      <button 
        onClick={handleGenerateSitemap}
        style={{
          padding: '10px 20px',
          margin: '10px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        Download Sitemap
      </button>
      <button 
        onClick={handleViewSitemap}
        style={{
          padding: '10px 20px',
          margin: '10px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        View Sitemap
      </button>
    </div>
  );
};

export default SitemapGenerator;